export function getOnlineDuration(loginTime) {
  const now = Date.now();
  const diff = Math.floor((now - loginTime) / 1000); // seconds

  const days = Math.floor(diff / (60 * 60 * 24));
  const hrs = Math.floor((diff % (60 * 60 * 24)) / 3600);
  const mins = Math.floor((diff % 3600) / 60);
  const secs = diff % 60;

  if (days > 0) return `${days}d ${hrs}h ${mins}m`;
  if (hrs > 0) return `${hrs}h ${mins}m ${secs}s`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
}
